import { useMemo } from 'react';
import { TaskId } from 'api/models';
import { Action, EventType, ObjectType } from 'api/pushes';
import { useProjectWSUpdates } from 'hooks/use-project-ws-updates';
import { useTaskDetailQuery, useTaskPaneUpdate } from 'queries/task';

/**
 *
 * @deprecated Use `TasksStore.ofId`. Additional information like attachments
 * should come from other stores.
 *
 *
 * only write the partucular task's specific functionality here
 * anything else go write somewhere else
 * dont come here
 */
export const useTaskDetailStore = (taskId: TaskId) => {
  const [, projectId] = taskId;
  const { data, isLoading, ...rest } = useTaskDetailQuery(taskId, {
    // keepPreviousData: true,
    refetchOnMount: true,
  });

  const { handleTaskSocketUpdate } = useTaskPaneUpdate(taskId);

  useProjectWSUpdates(
    projectId,
    handleTaskSocketUpdate,
    EventType(Action.Update, ObjectType.Task),
  );

  const query = useMemo(
    () => ({
      data: (data
        ? {
            ...data,
            project: data?.project?.projectId,
            subTasks: data?.subTasks?.map((e) => e?.taskId),
            // dependentTasks: data?.dependentTasks?.map((e) => e?.taskId),
          }
        : data) as import('data/tasks/schema').Task | undefined,
      isLoading,
      ...rest,
    }),
    [data, isLoading, rest],
  );

  return query;
};
